/**
 * The server's own names for the refusals the web tells apart.
 *
 * Every refusal comes as `{ errors: [{ id, title }] }`, and the id is what
 * the web reads when one answer has to be told from another with the same
 * status: the day's cap on a frame from the throttle, both 429; a promo
 * code unknown from one spent, from one already used. The swagger writes
 * down the envelope and not the ids, so these are read back out of the
 * backend's own files by `errorIds.test.ts` — a name changed on one side
 * without the other is the generic sentence over an answer the server had
 * spelled out, with the gate green.
 */
export const ERROR_ID = {
  /** The album already holds that day — `Selfie`'s uniqueness on `taken_on`. */
  dayTaken: "taken_on",
  /** The thirty answers one frame takes in a day (`ReactionsController`). */
  reactionCap: "reaction",
  /** The account is blocked — said at sign-in, and again mid-session. */
  account: "account",
  promoUnknown: "unknown_code",
  promoExhausted: "exhausted",
  promoAlreadyRedeemed: "already_redeemed",
} as const;
